// extracted by mini-css-extract-plugin
export default {"productImage":"SkeletonProduct_productImage__hjqUX","productName":"SkeletonProduct_productName__zszB9","productPrice":"SkeletonProduct_productPrice__Ob4Kb"};